module.exports = __webpack_public_path__ + "static/bvds-2625a9ed6a6e16a1700a918407bc3eac.svg";